module.exports = __webpack_public_path__ + "media/Images/SwirlPink-87ee52d8.svg";